export interface KeycloakConfig {
    URL: string
    Realm: string
    ClientID: string
}

export interface EnvConfig {
    HTTPListen: string
    Domain: string
    Keycloak: KeycloakConfig
}

export default function getEnvConfig(): EnvConfig {
    // @ts-expect-error: __envConfig came from backend
    const envConfig: EnvConfig = __envConfig
    return envConfig
}
